module.exports = __webpack_public_path__ + "img/activation-code-fr.6f8d53ba.svg";